if (!customElements.get('variant-delivery-time')) {
  class VariantDeliveryTime extends HTMLElement {
    constructor() {
      super();
      this.variantChangeUnsubscriber = undefined;
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    }

    onVariantChange(event) {
      if (event.data.sectionId !== this.dataset.sectionId) return;
      const updated = event.data.html.querySelector('variant-delivery-time');
      if (updated) this.innerHTML = updated.innerHTML;
    }
  }

  customElements.define('variant-delivery-time', VariantDeliveryTime);
}
